angular.module('FmsApp').factory("FarmFieldDetailFactory", ["$resource", function ($resource) {
    return $resource("/api/v1.0/fms/farmfielddetail/:field_slug/", {field_slug: '@field_slug'});
}]);
